module.exports = __webpack_public_path__ + "static/media/the-farms-being-run-from-space.8569e5f6.jpg";